// Main.js - COMPLETED
import React, { useLayoutEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CssBaseline } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@mui/material/styles";

import { setLoggedInUser } from "../redux/slices/userSlice";
import { setHeaders } from "../redux/slices/authSlice";

import theme from "../theme";

import MobileMain from "./mobile/MobileMain";
import { AuthFlowContainer } from "./AuthFlowContainer";
import WebMain from "./WebMain";

const useMobileStyles = makeStyles((theme) => ({
  container: {
    minHeight: "100vh",
    padding: "50px 12px",
    backgroundColor: "#F2FEFF",
  },
  title: {
    fontSize: "24px",
    color: "#158394",
    textAlign: "center",
  },
}));

const getQueryParam = (name) => {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
  } catch {
    return "";
  }
};

function Main() {
  const dispatch = useDispatch();
  const location = useLocation();

  const user = useSelector((state) => state.user.user);
  const hostname = window.location.hostname;
  const isMobileFlow = hostname.startsWith("tap.");
  const isKioskPublicRoute = ["/kiosk-editor", "/kioks-editor", "/kiosk-preview"].includes(
    location.pathname,
  );

  const macFromQuery = useMemo(
    () => (getQueryParam("mac") || getQueryParam("tag") || "").toLowerCase(),
    [],
  );

  const mobileClasses = useMobileStyles(theme);
  const navigate = useNavigate();
  const [dynamicMac, setDynamicMac] = useState(macFromQuery);
  const [decodedUser, setDecodedUser] = useState({})

  const handleMacChange = (newMac) => {
    setDynamicMac(newMac);
    // Updates the URL query param without full page reload
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set("tag", newMac);
    navigate(`?${currentParams.toString()}`, { replace: true });
  };


  const handleSetLoggedInUser = () => {
    const storedToken = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (storedToken) {
      dispatch(
        setHeaders({
          "Content-Type": "application/json",
          Authorization: `Bearer ${storedToken}`,
        }),
      );
      sessionStorage.removeItem("stayWelcomePage")
      dispatch(setLoggedInUser(decodedUser));
    }
  }

  useLayoutEffect(() => {
    const navigationEntries = performance.getEntriesByType("navigation");

    if (navigationEntries.length > 0) {
      const navType = navigationEntries[0].type;

      const storedUser = localStorage.getItem("user")
      const storedToken = localStorage.getItem("token")
      const stay = sessionStorage.getItem("stayWelcomePage")
      if (storedUser && storedToken) {
        try {
          const decodedUser = JSON.parse(atob(storedUser));
          if ((navType === "reload" && decodedUser?.id && !stay) || isMobileFlow) {
            handleSetLoggedInUser()
          }
          else {
            sessionStorage.setItem("stayWelcomePage", true)
          }
        } catch (err) {
          console.error("Error decoding stored user:", err);
        }
      }


    }
  }, [decodedUser]);

  if (isMobileFlow) {
    return (
      <>
        <CssBaseline />
        {user ? (
          <MobileMain
            key={dynamicMac}
            mac={dynamicMac}
            onMacChange={handleMacChange}
          />
        ) : (
          <AuthFlowContainer
            isMobileFlow={true}
            mobileClasses={mobileClasses}
            decodedUser={decodedUser}
            setDecodedUser={setDecodedUser}
            handleSetLoggedInUser={handleSetLoggedInUser}
          />
        )}
      </>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {user || isKioskPublicRoute ? (
        <WebMain />
      ) : (
        <AuthFlowContainer
          isMobileFlow={false}
          decodedUser={decodedUser}
          setDecodedUser={setDecodedUser}
          handleSetLoggedInUser={handleSetLoggedInUser}
        />
      )}
    </ThemeProvider>
  );
}

export default Main;
